import { closeDialog, selectFuseDialogProps } from '@fuse/core/FuseDialog/fuseDialogSlice';
import { useMediaQuery } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import { useTheme } from '@mui/material/styles';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';

/**
 * FuseDialog component
 * This component renders a material UI ```Dialog``` component
 * with properties pulled from the redux store
 * 
 * If the user is on mobile, the Dialog should go to fullscreen to display all of the content
 */
function FuseDialog() {
	const dispatch = useAppDispatch();
	const options = useAppSelector(selectFuseDialogProps);
	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

	return (
		<Dialog
			open={options.open}
			onClose={() => dispatch(closeDialog())}
			aria-labelledby="fuse-dialog-title"
			maxWidth={options.options?.maxWidth ?? 'xl'}
			fullWidth={options.options?.fullWidth ?? true}
			classes={{
				paper: `rounded-lg ${options.options?.paperClassName || ''}`
			}}
			fullScreen={fullScreen}
		>
			{options.children}
		</Dialog>
	);
}

export default FuseDialog;
